<div class="flex h-full flex-col">
  <div class="header relative p-3">
    <div class="title text-center text-lg">Reviews Image</div>
    <button
      type="button"
      class="close absolute top-[50%] right-3 -translate-y-[50%]"
      (click)="onCloseModal()">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>
  <div class="address-items flex-1 space-y-3 overflow-y-auto p-3">
    <form [formGroup]="reviewForm" class="flex h-full flex-col gap-3">
      <div
        class="mb-2 flex w-full gap-2 rounded-md bg-red-100 p-2 text-sm text-red-500"
        role="alert"
        *ngIf="errMessage">
        <p class="flex-1">
          {{ errMessage }}
        </p>
        <div class="w-10 text-right">
          <fa-icon
            class="cursor-pointer"
            [icon]="faTimes"
            (click)="errMessage = ''"></fa-icon>
        </div>
      </div>
      <div class="form-upload flex-1">
        <label
          for="image-placeholder"
          tabindex="0"
          (keypress)="media.click()"
          class="image placeholder relative block h-full w-full rounded-md border bg-slate-50 hover:bg-slate-100">
          <div class="file">
            <ng-container *ngIf="reviewForm.controls['image_file'].value">
              <img
                class="absolute left-1/2 h-full -translate-x-1/2 object-cover"
                [src]="reviewForm.controls['src_file'].value"
                alt="skinfit image" />
            </ng-container>
            <div
              *ngIf="!reviewForm.controls['image_file'].value"
              class="placeholder absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
              <fa-icon
                class="text-7xl text-slate-300"
                [icon]="faImage"></fa-icon>
              <div class="content mt-3 text-xs text-slate-500 md:text-base">
                <div>
                  <p class="my-3 text-sm text-slate-500">
                    <span class="font-medium text-slate-800">
                      Select from your storage
                    </span>
                    <br />
                    (.png, .jpg, .jpeg)
                  </p>
                </div>
              </div>
            </div>
          </div>
          <input
            id="image-placeholder"
            tabindex="-1"
            #media
            type="file"
            accept="image/*"
            class="h-full w-full cursor-pointer opacity-0"
            (change)="handleSkinFitFile($event)"
            (input)="handleSkinFitFile($event)" />
        </label>
      </div>
    </form>
  </div>
  <div class="footer flex items-center justify-end gap-3 p-3">
    <button
      type="button"
      class="rounded-md border border-primary-md-dark py-1 px-3 text-primary-md-dark"
      (click)="onCloseModal()"
      type="button">
      Cancel
    </button>
    <button
      type="submit"
      class="rounded-md bg-primary-md-dark py-1 px-3 text-white"
      [disabled]="loading"
      [ngClass]="{ 'opacity-50': loading }"
      (click)="onSubmit()">
      <span class="btn-label">Upload</span>
      <fa-icon
        class="load-icon"
        [ngClass]="{ hidden: !loading }"
        [icon]="faSpinner"
        [spin]="true"></fa-icon>
    </button>
  </div>
</div>
